import classnames from "classnames";

import Checkbox, { CheckboxProps } from "../../Checkbox";
import "./GreenCheckbox.scss";

const GreenCheckbox = (props: CheckboxProps) => {
  return (
    <Checkbox
      {...props}
      checkboxClassName={classnames(
        "GreenCheckbox__checkbox",
        props.checkboxClassName
      )}
      checkboxSelectedClassName="GreenCheckbox__checkbox--checked"
    />
  );
};

export default GreenCheckbox;
